import React from 'react';
import PropTypes from 'prop-types';
import PageTitle from '../../../../../components/pageTitle';
import Navigation from '../../../../../components/navigation';
import InputFile from '../../../../../components/inputFile';
import ValidationMessage from '../../../../../components/validation/ValidationMessage';
import AttachedFile from '../../../../../components/files/attachedFile';


const AddNew = ({
  t,
  multId,
  errors,
  onChange,
  formData,
  sendRequest,
  mulTempFiles,
  enableCoverColor,
  backgroundCover,
  backgroundColor,
}) => (
  <React.Fragment>
    <PageTitle
      title={t('Feedback')}
      pageSubTitle={t('Add new')}
      backgroundPage={backgroundColor}
      backgroundCover={backgroundCover}
      enableCoverColor={enableCoverColor}
    />
    <section className="Blog2 boxs simplepage2_D fedbackpage">
      <div className="container">
        <div className="Blog2inner boxs pdlr">
          <Navigation />
          <div className="middleKB">
            <div className="addnewfedbck boxs">
              <div className="boxs addfdbckcmntD">
                <h6>{t('Describe your feature request')}</h6>
                <div className="boxs cmntwfile">
                  <div className="boxs fdbck">
                    <input
                      type="text"
                      name="title"
                      className="form-control form-controlsearch"
                      placeholder={t('Title')}
                      onChange={onChange}
                      value={formData.title}
                    />
                    <ValidationMessage
                      message={errors.title && errors.title.message}
                      valid={!errors.title}
                    />
                  </div>
                  <div className="boxs fdbck">
                    <textarea
                      name="body"
                      value={formData.body}
                      className="form-control form-controlsearch"
                      placeholder={t('Your message')}
                      onChange={onChange}
                    />
                    {/*<ValidationMessage*/}
                      {/*message={errors.body && errors.body.message}*/}
                      {/*valid={!errors.body}*/}
                    {/*/>*/}
                  </div>
                  <div className="boxs fontmulisemi Attchfilefdbck">
                    <div className="leftfbw">
                      <div className="boxs">
                        <span className="attchfilefbck ">{t('Attached files')}<span>({mulTempFiles[multId] ? mulTempFiles[multId].length : 0})</span>:</span>
                      </div>
                    </div>
                    <div>
                      <InputFile
                        id={multId}
                        groupFile
                        label={t('Attach a file')}
                        fields={prop => (
                          <AttachedFile
                            file={prop.file}
                            onRemove={prop.onRemove}
                            attach
                            upload
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="sndrqst boxs">
                    <button className="sndrqstbtn" onClick={sendRequest}>
                      {t('Send the request')}
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </React.Fragment>
);

AddNew.propTypes = {
  t: PropTypes.func.isRequired,
};

export default AddNew;



// WEBPACK FOOTER //
// ./src/views/modules/feedback/feedbackItem/addNew/AddNew.jsx